import Vue from 'vue'
import Vuex from 'vuex'
import getters from './getters'
import mutations from './mutations'

Vue.use(Vuex)

const state = {
  collapse: false,
}

export default new Vuex.Store({
  getters,
  state,
  mutations
})



//////////////////
// WEBPACK FOOTER
// ./store/index.js
// module id = null
// module chunks = 